<template>
    <div class="custom-settings-popover">
        <input type="hidden" v-model="filterTitle">
        <div class="filter-settings filter-settings-wrapper">
            <v-bar wrapper="v-bar-filter-settings">
                <div class="subtitle">
                    фильтрация по:
                </div>
                <el-form label-position="top" class="deal-filter-main" @keyup.enter.native="filterApplied">
                    <el-form-item :label="fieldsNames.id" v-if="isColumnVisible('id')">
                        <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.created_at" v-if="isColumnVisible('created_at')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.created_at.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.created_at.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.tags" v-if="isColumnVisible('tags')">
                        <el-select
                            v-model="filterModel.tags"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.tags"
                            size="mini"
                        >
                            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.status_id" v-if="isColumnVisible('status')">
                        <el-select
                            v-model="filterModel.status_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.status_id"
                            size="mini"
                        >
                            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.link_id" v-if="isColumnVisible('link')">
                        <el-select
                            v-model="filterModel.link_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.link_id"
                            size="mini"
                        >
                            <el-option v-for="item in linkList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.office_id" v-if="isColumnVisible('office')">
                        <el-select
                            v-model="filterModel.office_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.office_id"
                            size="mini"
                        >
                            <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.responsible_user_id" v-if="isColumnVisible('responsible_user')">
                        <el-select
                            v-model="filterModel.responsible_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.responsible_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in responsibleList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_id" v-if="isColumnVisible('contact_name')">
                        <el-input v-model="filterModel.contact_name" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_phone" v-if="isColumnVisible('contact_phone')">
                        <el-input v-model="filterModel.contact_phone" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_email" v-if="isColumnVisible('contact_email')">
                        <el-input v-model="filterModel.contact_email" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.address" v-if="isColumnVisible('address')">
                        <el-input v-model="filterModel.address" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.title" v-if="isColumnVisible('title')">
                        <el-input v-model="filterModel.title" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.budget" v-if="isColumnVisible('budget')">
                        <el-input v-model="filterModel.budget" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.volume" v-if="isColumnVisible('volume')">
                        <el-input v-model="filterModel.volume" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.square_m2" v-if="isColumnVisible('square_m2')">
                        <el-input v-model="filterModel.square_m2" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.profile_type_id" v-if="isColumnVisible('profile_type')">
                        <el-select
                            v-model="filterModel.profile_type_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.profile_type_id"
                            size="mini"
                        >
                            <el-option v-for="item in profileTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish" v-if="isColumnVisible('finish')">
                        <el-checkbox v-model="filterModel.finish">
                            {{ fieldsNames.finish | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish_amount" v-if="isColumnVisible('finish_amount')">
                        <el-input v-model="filterModel.finish_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie" v-if="isColumnVisible('jalousie')">
                        <el-checkbox v-model="filterModel.jalousie">
                            {{ fieldsNames.jalousie | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie_amount" v-if="isColumnVisible('jalousie_amount')">
                        <el-input v-model="filterModel.jalousie_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.promising_customer" v-if="isColumnVisible('promising_customer')">
                        <el-checkbox v-model="filterModel.promising_customer">
                            {{ fieldsNames.promising_customer | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.to_production" v-if="isColumnVisible('to_production')">
                        <el-checkbox v-model="filterModel.to_production">
                            {{ fieldsNames.to_production | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurement_date" v-if="isColumnVisible('measurement_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.measurement_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.measurement_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurement_time" v-if="isColumnVisible('measurement_time')">
                        <el-select
                            v-model="filterModel.measurement_time"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            autocomplete
                            clearable
                            placeholder=""
                            size="mini"
                        >
                            <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurer_user_id" v-if="isColumnVisible('measurer_user')">
                        <el-select
                            v-model="filterModel.measurer_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.measurer_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in measurerList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" v-if="isColumnVisible('difficult_metering')">
                        <el-checkbox v-model="filterModel.difficult_metering">
                            {{ fieldsNames.difficult_metering | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" v-if="isColumnVisible('refuse_before_metering')">
                        <el-checkbox v-model="filterModel.refuse_before_metering">
                            {{ fieldsNames.refuse_before_metering | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" v-if="isColumnVisible('tech_refusal')">
                        <el-checkbox v-model="filterModel.tech_refusal">
                            {{ fieldsNames.tech_refusal | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" v-if="isColumnVisible('re_measurement')">
                        <el-checkbox v-model="filterModel.re_measurement">
                            {{ fieldsNames.re_measurement | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.re_measurement_date" v-if="isColumnVisible('re_measurement_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.re_measurement_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.re_measurement_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.re_measurement_time" v-if="isColumnVisible('re_measurement_time')">
                        <el-select
                            v-model="filterModel.re_measurement_time"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            autocomplete
                            clearable
                            placeholder=""
                            size="mini"
                        >
                            <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurer_bonus" v-if="isColumnVisible('measurer_bonus')">
                        <el-input v-model="filterModel.measurer_bonus" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contract_number" v-if="isColumnVisible('contract_number')">
                        <el-input v-model="filterModel.contract_number" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contract_date" v-if="isColumnVisible('contract_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.contract_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.contract_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.conclusion_id" v-if="isColumnVisible('conclusion')">
                        <el-select
                            v-model="filterModel.conclusion_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            clearable
                            :placeholder="fieldsNames.conclusion_id"
                            size="mini"
                        >
                            <el-option v-for="item in conclusionTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.start_production_date" v-if="isColumnVisible('start_production_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.start_production_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.start_production_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.discount" v-if="isColumnVisible('discount')">
                        <el-input v-model="filterModel.discount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.prepay" v-if="isColumnVisible('prepay')">
                        <el-input v-model="filterModel.prepay" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.pay_type_id" v-if="isColumnVisible('pay_type')">
                        <el-select
                            v-model="filterModel.pay_type_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.pay_type_id"
                            size="mini"
                        >
                            <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installer_balance" v-if="isColumnVisible('installer_balance')">
                        <el-input v-model="filterModel.installer_balance" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.garbage_removal_id" v-if="isColumnVisible('garbage_removal')">
                        <el-select
                            v-model="filterModel.garbage_removal_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.garbage_removal_id"
                            size="mini"
                        >
                            <el-option v-for="item in garbageRemovalTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.production_cost" v-if="isColumnVisible('production_cost')">
                        <el-input v-model="filterModel.production_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.in_production_id" v-if="isColumnVisible('in_production')">
                        <el-select
                            v-model="filterModel.in_production_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.in_production_id"
                            size="mini"
                        >
                            <el-option v-for="item in factoriesList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie_cost" v-if="isColumnVisible('jalousie_cost')">
                        <el-input v-model="filterModel.jalousie_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish_cost" v-if="isColumnVisible('finish_cost')">
                        <el-input v-model="filterModel.finish_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.delivery_date" v-if="isColumnVisible('delivery_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.delivery_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.delivery_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installation_date" v-if="isColumnVisible('installation_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.installation_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.installation_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installation_user_id" v-if="isColumnVisible('installation_user')">
                        <el-select
                            v-model="filterModel.installation_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.installation_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in installerList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installers_salary" v-if="isColumnVisible('installers_salary')">
                        <el-input v-model="filterModel.installers_salary" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installers_debt" v-if="isColumnVisible('installers_debt')">
                        <el-input v-model="filterModel.installers_debt" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.additional_work" v-if="isColumnVisible('additional_work')">
                        <el-input v-model="filterModel.additional_work" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_opening_date" v-if="isColumnVisible('complaint_opening_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.complaint_opening_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.complaint_opening_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_amount" v-if="isColumnVisible('complaint_amount')">
                        <el-input v-model="filterModel.complaint_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.guilty_id" v-if="isColumnVisible('guilty')">
                        <el-select
                            v-model="filterModel.guilty_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            clearable
                            :placeholder="fieldsNames.guilty_id"
                            size="mini"
                            @change="handleChangeGuilty"
                        >
                            <el-option v-for="item in guiltyTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.culprit_id" v-if="isColumnVisible('culprit')">
                        <el-select
                            v-model="filterModel.culprit_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.culprit_id"
                            size="mini"
                        >
                            <el-option v-for="item in culpritList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_performer_id" v-if="isColumnVisible('complaint_performer')">
                        <el-select
                            v-model="filterModel.complaint_performer_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.complaint_performer_id"
                            size="mini"
                        >
                            <el-option v-for="item in complaintPerformerList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.specialist_payment" v-if="isColumnVisible('specialist_payment')">
                        <el-input v-model="filterModel.specialist_payment" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_materials_cost" v-if="isColumnVisible('complaint_materials_cost')">
                        <el-input v-model="filterModel.complaint_materials_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_closing_date" v-if="isColumnVisible('complaint_closing_date')">
                        <div class="datepicker-row">
                            <span class="data-label">C</span>
                            <el-date-picker
                                v-model="dates.complaint_closing_date.min"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                        <div class="datepicker-row">
                            <span class="data-label">По</span>
                            <el-date-picker
                                v-model="dates.complaint_closing_date.max"
                                type="date"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                size="mini"
                                class="w100"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.custom_fields" v-if="isColumnVisible('custom_fields')">
                        <el-input v-model="filterModel.custom_fields" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.unread_messages" v-if="isColumnVisible('unread_messages')">
                        <el-checkbox v-model="filterModel.unread_messages">
                            {{ fieldsNames.unread_messages | uppercase }}
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div class="actions-wrapper">
                    <div class="btn btn-default grey" @click="hideFilterSettings">
                        отменить
                    </div>
                    <div class="btn btn-default orange" @click="filterApplied">
                        применить
                    </div>
                </div>
            </v-bar>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/common/eventBus';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';
import VBar from 'v-bar';

export default {
    name: 'FilterSettingsMobile',
    data() {
        return {
            pickerOptions,
            fieldsNames: {},
            dates: {
                created_at: {
                    min: null,
                    max: null
                },
                measurement_date: {
                    min: null,
                    max: null
                },
                re_measurement_date: {
                    min: null,
                    max: null
                },
                installation_date: {
                    min: null,
                    max: null
                },
                contract_date: {
                    min: null,
                    max: null
                },
                start_production_date: {
                    min: null,
                    max: null
                },
                delivery_date: {
                    min: null,
                    max: null
                },
                complaint_opening_date: {
                    min: null,
                    max: null
                },
                complaint_closing_date: {
                    min: null,
                    max: null
                }
            },
            dateAttributes: [
                'created_at',
                'contract_date',
                'measurement_date',
                'start_production_date',
                'delivery_date',
                'installation_date',
                'complaint_opening_date',
                'complaint_closing_date'
            ]
        };
    },
    components: { VBar },
    props: {
        attributes: {
            type: Object,
            default: () => {}
        },
        filter: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        hideFilterSettings() {
            eventBus.$emit('hideFilterSettings');
        },
        filterApplied() {
            this.joinDates();
            this.$emit('filterApplied', this.filterModel);
            this.hideFilterSettings();
        },
        isColumnVisible(colId) {
            return this.attributes[colId].hide === false;
        },
        handleChangeGuilty(value) {
            if (value) {
                this.filterModel.complaint_performer_id = [];
                this.filterModel.culprit_id = [];
            }
        },
        //собираем даты с промежутками
        joinDates() {
            Object.keys(this.dates).forEach((item) => {
                this.filterModel[item] = null;
                const min = this.dates[item].min;
                const max = this.dates[item].max;
                if (min !== null && max !== null) {
                    this.filterModel[item] = [min, max];
                }
                if (typeof (min) === 'undefined' || typeof (max) === 'undefined') {
                    this.dates[item].min = null;
                    this.dates[item].max = null;
                    this.filterModel[item] = null;
                }
            });
        },
        getNames(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]} : ${this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ')}; `;
            } else {
                return '';
            }
        },
        getOneName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]} : ${obj.filter(item => item.id === this.filterModel[field]).map(item => item.name).join('')}; `;
            } else {
                return '';
            }
        }
    },
    filters: {
        uppercase: function(value) {
            if (!value) return '';
            value = value.toString();
            return value.toUpperCase();
        }
    },
    mounted() {
        Object.keys(this.attributes).forEach((item) => {
            this.$set(this.fieldsNames, item, this.attributes[item].name);
        });

        //начальные значения для дэйтпикеров
        Object.keys(this.dates).forEach((item) => {
            if (this.filter[item] !== null) {
                this.dates[item].min = this.filter[item][0];
                this.dates[item].max = this.filter[item][1];
            }
        });
    },
    computed: {
        filterModel() {
            return this.filter;
        },
        tagList() {
            return this.$store.state.references.tags;
        },
        statusList() {
            return this.$store.state.references.dealStatuses;
        },
        linkList() {
            return this.$store.state.references.links;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        responsibleList() {
            return this.$store.state.references.employers;
        },
        measurerList() {
            return this.$store.state.references.measurers;
        },
        installerList() {
            return this.$store.state.references.installers;
        },
        payTypesList() {
            return this.$store.state.references.payTypes;
        },
        factoriesList() {
            return this.$store.state.references.factories;
        },
        profileTypes() {
            return this.$store.state.references.profileTypes;
        },
        conclusionTypes() {
            return this.$store.state.references.conclusions;
        },
        garbageRemovalTypes() {
            return this.$store.state.references.garbageRemovals;
        },
        guiltyTypes() {
            return this.$store.state.references.guilty;
        },
        measurementTimeList() {
            return this.$store.state.references.measurementTimes;
        },
        culpritList() {
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.factory) {
                return this.factoriesList;
            }
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.measurer) {
                return this.measurerList;
            }
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.installer) {
                return this.installerList;
            }
            return this.responsibleList;
        },
        complaintPerformerList() {
            return this.$store.state.references.complaintPerformer;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'responsible_user_id':
                            case 'measurer_user_id':
                            case 'installation_user_id':
                                result += this.getNames(this.responsibleList, field);
                                break;
                            case 'status_id':
                                result += this.getNames(this.statusList, field);
                                break;
                            case 'link_id':
                                result += this.getNames(this.linkList, field);
                                break;
                            case 'tags':
                                result += this.getNames(this.tagList, field);
                                break;
                            case 'office_id':
                                result += this.getNames(this.officeList, field);
                                break;
                            case 'pay_type_id':
                                result += this.getNames(this.payTypesList, field);
                                break;
                            case 'profile_type_id':
                                result += this.getNames(this.profileTypes, field);
                                break;
                            case 'in_production_id':
                                result += this.getNames(this.factoriesList, field);
                                break;
                            case 'garbage_removal_id':
                                result += this.getNames(this.garbageRemovalTypes, field);
                                break;
                            case 'complaint_performer_id':
                                result += this.getNames(this.complaintPerformerList, field);
                                break;
                            case 'culprit_id':
                                result += this.getNames(this.culpritList, field);
                                break;
                            case 'created_at':
                            case 'contract_date':
                            case 'measurement_date':
                            case 'start_production_date':
                            case 'delivery_date':
                            case 'installation_date':
                            case 'complaint_opening_date':
                            case 'complaint_closing_date':
                                if (this.filterModel[field][0] !== null && this.filterModel[field][1] !== null) {
                                    result += `${this.fieldsNames[field]}: c ${this.filterModel[field][0]}
                                    по ${this.filterModel[field][1]}; `;
                                }
                                break;
                            default:
                                if (!this.dateAttributes.includes(field)) {
                                    result += `${this.fieldsNames[field]}: ${this.filterModel[field]}; `;
                                }
                        }
                    }
                    if (typeof this.filterModel[field] === 'number') {
                        switch (field) {
                            case 'conclusion_id':
                                result += this.getOneName(this.conclusionTypes, field);
                                break;
                            case 'guilty_id':
                                result += this.getOneName(this.guiltyTypes, field);
                                break;
                        }
                    }
                }
            }

            return this.$emit('get-filter-title', result);
        }
    }
};
</script>
